import { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
const Nav = ({ menu }) => {
    menu = Array.isArray(menu) ? menu : [menu];
    const location = useLocation();
    const [lastUrl, setLastUrl] = useState(localStorage.getItem('lastVisitedUrl'));

    const handleSaveUrl = (url) => {
        localStorage.setItem('lastVisitedUrl', url);
        setLastUrl(url);
    };

    const handleNavigation = (targetUrl, e) => {
        if (location.pathname === targetUrl) {
            e.preventDefault();
            window.location.reload();
        }
    };

    useEffect(() => {
        setLastUrl(localStorage.getItem('lastVisitedUrl'));
    }, []);

    const isActiveItem = (item) => {
        const hasInternalUrl = item?.internalUrl;
        const extractedUrl = location.pathname.split('-')[0];
        if (extractedUrl === item.url) {
            return true;
        } else if (item.urlCpnItem && extractedUrl.startsWith(item.urlCpnItem) && lastUrl === item.url) {
            return true;
        } else if (hasInternalUrl && hasInternalUrl?.some((url) => extractedUrl.startsWith(url))) {
            return true;
        } else {
            return false;
        }
    };

    return (
        <div id="tab-follow">
            <div className="container">
                <ul className="tabs-no-border center">
                    {menu.map((item, index) => (
                        <li
                            key={index}
                            className={isActiveItem(item) ? 'active' : ''}
                            onClick={(e) => {
                                handleSaveUrl(item.url);
                                handleNavigation(item.url, e);
                            }}
                        >
                            <NavLink to={item.url}>{item.context}</NavLink>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default Nav;
